import { QuestionScreenLayout } from '@/features/advisor-onboarding/questionnaire/components/question-screen-layout';
import { QuestionBodyShortText } from '@/features/advisor-onboarding/questionnaire/components/question-body-short-text';

import { useQuestionScreen } from '@/features/advisor-onboarding/questionnaire/contexts/question-screen-context';
import { useShortTextQuestion } from '@/features/advisor-onboarding/questionnaire/hooks/use-short-text-question';

export function ShortTextScreen() {
  const { question, answers, isSubmitting, submitAnswer } = useQuestionScreen();
  const initialValue = (answers[question.id] as string | undefined) ?? '';
  const placeholder = (question as { placeholder?: string }).placeholder;

  const { value, setValue, isValid, submit } = useShortTextQuestion({
    question,
    initialValue,
    onSubmit: submitAnswer,
  });

  return (
    <QuestionScreenLayout
      onNext={submit}
      nextDisabled={!isValid}
    >
      <QuestionBodyShortText
        value={value}
        onChange={setValue}
        placeholder={placeholder}
        disabled={isSubmitting}
      />
    </QuestionScreenLayout>
  );
}
